
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmTriggerGoogle as ObiAlarmTriggerGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-trigger-google.js';
 
 
 

 
 export const ObiAlarmTriggerGoogle = createComponent({
   react: React,
   tagName: 'obi-alarm-trigger-google',
   elementClass: ObiAlarmTriggerGoogleElement,
   events: {
     
   }
  });
 
 